import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function YourHomePerfectlyFitted() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  return <section data-section-id="28802" id="unveil-your-radiance" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/5 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614369/img/boudoir_high_key_portrait.png)] bg-cover bg-center bg-no-repeat bg-fixed" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-6 md:px-12 text-center">
        <div className={`transition-all duration-1000 ease-out transform ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-foreground mb-6 tracking-tight drop-shadow-md font-serif">
            Unveil Your Radiance
          </h1>
          
          <p className="text-xl md:text-2xl text-foreground/90 mb-10 font-medium max-w-2xl mx-auto leading-relaxed drop-shadow-sm font-sans tracking-wide">
            Empowering, sophisticated, and discreet luxury boudoir photography for the modern woman.
          </p>

          <div className="flex justify-center">
            <Link to="#">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border-none rounded-none py-8 px-10 text-lg uppercase tracking-widest font-semibold shadow-xl transition-transform hover:-translate-y-1">
                Begin Your Transformation
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}